// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography } from '@mui/material';
// i18n
import { useTranslation } from 'react-i18next';
// components
import Page from '../components/Page';
// sections
import { ResetPasswordForm } from '../sections/auth/resetpassword';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const TextHeader = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
}));

// ----------------------------------------------------------------------

export default function ResetPassword() {
  const { t } = useTranslation();

  return (
    <Page title="Forgot Password">
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <TextHeader>
              <Typography variant="h4" gutterBottom>
                {t('forgotpassword.title')}
              </Typography>

              <Typography sx={{ color: 'text.secondary', mb: 5 }}>{t('forgotpassword.body')}</Typography>
            </TextHeader>
            <ResetPasswordForm />
          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
